export * from '@src/components/templates/occl/forTesting.tmpl.js';
export * from '@src/components/templates/occl/TefComs4p/index.js';
export * from '@src/components/templates/occl/tefComsButton.tmpl.js';
export * from '@src/components/templates/occl/tefComsCancelButton.tmpl.js';
